import { apiClient } from '../client'
import type { ApproveDeviceRequest, ApproveDeviceResponse, DeviceGroups } from '@milliswift/types'

/**
 * Device pairing and lifecycle.
 *
 * `list` returns pending, active and revoked as separate arrays, so the UI can
 * render approvals without filtering. Polling this on an interval is the
 * fallback when the push channel is unavailable.
 */
export const devicesApi = {
  list: () => apiClient.get<DeviceGroups>('/api/v1/devices').then((r) => r.data),

  approve: (pairingId: string, data: ApproveDeviceRequest = {}) =>
    apiClient
      .post<ApproveDeviceResponse>(`/api/v1/devices/${pairingId}/approve`, data)
      .then((r) => r.data),

  reject: (pairingId: string) =>
    apiClient.post(`/api/v1/devices/${pairingId}/reject`).then(() => undefined),

  revoke: (deviceId: string) =>
    apiClient.delete(`/api/v1/devices/${deviceId}`).then(() => undefined),
}
